import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiHelper } from 'cad/common/services/api/api-helper';

@Injectable()
export class BaRelated {

  public endpoint: string = 'associate/business-associate/';
  public suffix: string = '/related/forward';

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (baId: string | number): Observable<any> => {
    return this.apiHelper.request(this.endpoint + baId + this.suffix);
  }

  public save = (dataList: any[]): Observable<any> => {
    return this.apiHelper.request(this.endpoint + dataList[0].baId + this.suffix, { body: dataList });
  }
}
